<div [formGroup]="parts" class="cronInputContainer">
    @if (!!labelKey) {
        <span class="label">{{ labelKey | translate }}</span>
    }
    <div class="timeInputContainer">
        <mat-form-field class="hourInput">
            <mat-label>{{ 'CronInput.Hour' | translate }}</mat-label>
            <input matInput type="number" min="0" max="23" step="1" formControlName="hour" />
        </mat-form-field>
        <span>:</span>
        <mat-form-field class="minuteInput">
            <mat-label>{{ 'CronInput.Minute' | translate }}</mat-label>
            <input matInput type="number" min="0" max="59" step="1" formControlName="minute" />
        </mat-form-field>
    </div>
    <div class="settingsInputContainer">
        <mat-form-field class="daysOfMonthInput">
            <mat-label>{{ 'CronInput.DaysOfMonth' | translate }}</mat-label>
            <mat-select formControlName="daysOfMonth" multiple>
                @for (dayOfMonth of daysOfMonth; track dayOfMonth) {
                    <mat-option [value]="dayOfMonth">{{ dayOfMonth }}</mat-option>
                }
            </mat-select>
            <mat-hint>{{ 'CronInput.NoSelectionEqualsEverything' | translate }}</mat-hint>
        </mat-form-field>
        <mat-form-field class="monthsInput">
            <mat-label>{{ 'CronInput.Months' | translate }}</mat-label>
            <mat-select formControlName="months" multiple>
                @for (month of months; track month) {
                    <mat-option [value]="month">{{ month }}</mat-option>
                }
            </mat-select>
            <mat-hint>{{ 'CronInput.NoSelectionEqualsEverything' | translate }}</mat-hint>
        </mat-form-field>
        <mat-form-field class="daysOfWeekInput">
            <mat-label>{{ 'CronInput.DaysOfWeek' | translate }}</mat-label>
            <mat-select formControlName="daysOfWeek" multiple>
                @for (dayOfWeek of daysOfWeek; track dayOfWeek) {
                    <mat-option [value]="dayOfWeek">{{ dayOfWeek }}</mat-option>
                }
            </mat-select>
            <mat-hint>{{ 'CronInput.NoSelectionEqualsEverything' | translate }}</mat-hint>
        </mat-form-field>
    </div>
</div>
